// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"26df427a","135":"61a9dfad","526":"87b65457","528":"ebcc8675","787":"1ba44449"}[chunkId] + ".chunk.js";
};